import { InputLabel, OutlinedInput, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingButton from '@mui/lab/LoadingButton';
import { InitPageContainer } from 'components/views/InitPageContainer/InitPageContainer';
import { RoutePaths } from 'constants/RoutePaths';
import { emailRegex } from 'constants/regex';
import { useForgotPassword } from 'hooks/useForgotPassword';
import { StyledFormControl, InfoBox, InfoText } from 'components/views/forgotPassword/ForgotPasswordPage.styles';
import { StyledErrorDiv, StyledInformationDiv } from "@theme/styledComponents";

export const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [emailSent, setEmailSent] = useState(false);
    const { processForgotPassword, forgotPasswordPending } = useForgotPassword();

    const { t } = useTranslation();
    const theme = useTheme();
  
    const validateEmail = () => {
        if (email === '') {
            setEmailError(t('forgotPasswordPage.emailRequired'));
            return false;
        }
        if (!emailRegex.test(email)) {
            setEmailError(t('forgotPasswordPage.emailInvalid'));
            return false;
        }
        setEmailError('');
        return true;
    };

    const handleForgotPassword = async () => {
        const isEmailValid = validateEmail();
        
        if (isEmailValid) {
            const res = await processForgotPassword({ email });
            if (res.status === 200) {
                setEmailSent(true);
            }
        }
    }

  
    return (
      <InitPageContainer title={t('forgotPasswordPage.resetPassword')} footerText={t('forgotPasswordPage.backToLogin')} footerUrl={RoutePaths.LOGIN} cardHeight='500px'>
            {emailSent ? (
              <StyledInformationDiv>
                {t("forgotPasswordPage.emailSent")}
                </StyledInformationDiv>)
            : <Stack spacing={theme.spacing(4)}>
            <StyledFormControl variant="outlined">
              <InputLabel htmlFor="email">{t('resetPassword.emailLabel')}</InputLabel>
              <OutlinedInput
                id="email"
                label={t('resetPassword.emailLabel')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={validateEmail}
              />
               {emailError && <StyledErrorDiv>{emailError}</StyledErrorDiv>}              
            </StyledFormControl>
            <InfoBox>
              <InfoText variant='caption' textAlign={'center'}>
                {t('forgotPasswordPage.initialEmailAddress')}
              </InfoText>
            </InfoBox>
            <InfoBox>
              <InfoText variant='caption'>
                {t('forgotPasswordPage.afterClickReset')}
              </InfoText>
            </InfoBox>
                <LoadingButton disabled={!email || !!emailError} loading={forgotPasswordPending} variant='contained' color='primary' onClick={handleForgotPassword}>{t('forgotPasswordPage.resetPassword')}</LoadingButton>            
            
        </Stack>
        }
        </InitPageContainer>
    );
  };